import { Badge } from 'reactstrap';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledBadge = styled(Badge)`
  background: #b00ab6;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 8px 12px;
  border-radius: 4px;
  height: max-content;
  align-self: center;
  text-transform: none;

  &.small-badge {
    font-size: 12px;
    font-weight: 700;
    line-height: 10px;
    padding: 4px 4.5px;
    border-radius: 2px;
  }
`;
